import { AxiosCustomRequest } from '../types';
import { objectKeysToSnakeCase } from '../utils/objectKeysTo.js';

export function requestDataToSnakeCase(request: AxiosCustomRequest) {
  const snakeCaseBody = request.clientOptions?.request?.snakeCaseBody;
  if (snakeCaseBody === false) {
    return request;
  }

  if (request.headers?.['Content-Type'] === 'application/json') {
    return {
      ...request,
      data: objectKeysToSnakeCase(request.data),
    };
  }

  return request;
}
